// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_uPO","cls2":"LoswpPackPitch-cls2_k6f LoswpPackPitch-cls1_uPO"};